/**
 * NAV-RISKS
 * Navigation container for risks module
 * Back button & header with actions & tabs
 */

import NavFocus, { NavFocusAction } from "@/nav/nav.focus"
import { useNavigate } from "react-router-dom"
import { SessionDashboardTab } from "@/redux/_session.types"
import { IconDefinition } from "@fortawesome/free-solid-svg-icons"

interface RisksTab {
  id: string
  label: string
  icon: IconDefinition
}

interface Props {
  children: any
  text?: string
  tabs?: RisksTab[]
  actions?: NavFocusAction[]
  onBack?: () => void
  isBackDisabled?: boolean
}

export default function NavRisks({
  children,
  text,
  tabs,
  actions = [],
  onBack,
  isBackDisabled = false
}: Props) {
  const navigate = useNavigate()

  function handleBack() {
    if (onBack) {
      onBack()
    } else {
      navigate("/duerp")
    }
  }

  function handleAction(actionId: string) {
    // Check if it's a tab
    if (tabs?.some((t) => t.id === actionId)) {
      navigate(actionId)
      return
    }

    // Check if it's an action with onClick
    const action = actions.find((a) => a.id === actionId)
    if (action && "onClick" in action && typeof (action as any).onClick === "function") {
      (action as any).onClick()
    }
  }

  // Convert RisksTab to SessionDashboardTab format for NavFocus
  const navFocusTabs: SessionDashboardTab[] | undefined = tabs?.map((tab) => ({
    id: tab.id,
    label: tab.label,
    icon: tab.icon
  }))

  return (
    <NavFocus
      text={text}
      tabs={navFocusTabs}
      actions={actions}
      onBack={handleBack}
      onAction={handleAction}
      isBackDisabled={isBackDisabled}>
      {children}
    </NavFocus>
  )
}